/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookingTolerancesAggregatorProviderMap,
    BookingTolerancesAggregatorProviderMapFromJSON,
    BookingTolerancesAggregatorProviderMapFromJSONTyped,
    BookingTolerancesAggregatorProviderMapToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingTolerancesListConfiguration
 */
export interface BookingTolerancesListConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof BookingTolerancesListConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof BookingTolerancesListConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BookingTolerancesListConfiguration
     */
    readonly relevances?: Array<number> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof BookingTolerancesListConfiguration
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<BookingTolerancesAggregatorProviderMap>}
     * @memberof BookingTolerancesListConfiguration
     */
    readonly aggregatorProviderMaps?: Array<BookingTolerancesAggregatorProviderMap> | null;
}

export function BookingTolerancesListConfigurationFromJSON(json: any): BookingTolerancesListConfiguration {
    return BookingTolerancesListConfigurationFromJSONTyped(json, false);
}

export function BookingTolerancesListConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingTolerancesListConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevances': !exists(json, 'relevances') ? undefined : json['relevances'],
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'aggregatorProviderMaps': !exists(json, 'aggregatorProviderMaps') ? undefined : (json['aggregatorProviderMaps'] === null ? null : (json['aggregatorProviderMaps'] as Array<any>).map(BookingTolerancesAggregatorProviderMapFromJSON)),
    };
}

export function BookingTolerancesListConfigurationToJSON(value?: BookingTolerancesListConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


